/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Actions for SettingsLabels component
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.1
 * @since 1.3.0
 */

import { createAction } from '../../../../modules/app/createAction';
import {
    ADD_SETTINGS_LABEL_ACTION,
    ADD_SETTINGS_LABEL_FAILURE,
    ADD_SETTINGS_LABEL_SUCCESS,
    GET_SETTINGS_LABELS_LIST_ACTION,
    GET_SETTINGS_LABELS_LIST_FAILURE,
    GET_SETTINGS_LABELS_LIST_SUCCESS,
    REMOVE_SETTINGS_LABEL_ACTION,
    REMOVE_SETTINGS_LABEL_FAILURE,
    REMOVE_SETTINGS_LABEL_SUCCESS,
} from './settingsLabelsConstants';
import {
    IGetSettingsLabelsListActionPayload,
    IGetSettingsLabelsListSuccessPayload,
    IRemoveSettingsLabelSuccessPayload,
    TAddSettingsLabelAction,
    TAddSettingsLabelFailure,
    TAddSettingsLabelSuccess,
    TGetSettingsLabelsListAction,
    TGetSettingsLabelsListFailed,
    TGetSettingsLabelsListSuccess,
    TRemoveSettingsLabelAction,
    TRemoveSettingsLabelFailure,
    TRemoveSettingsLabelSuccess,
} from './settingsLabelsTypes';

/**
 * Settings Labels
 */

export const getSettingsLabelsListAction =
    (payload: IGetSettingsLabelsListActionPayload): TGetSettingsLabelsListAction =>
        createAction(GET_SETTINGS_LABELS_LIST_ACTION, payload);

export const getSettingsLabelsListSuccess =
    (payload: IGetSettingsLabelsListSuccessPayload): TGetSettingsLabelsListSuccess =>
        createAction(GET_SETTINGS_LABELS_LIST_SUCCESS, payload);

export const getSettingsLabelsListFailure =
    (payload: string): TGetSettingsLabelsListFailed =>
        createAction(GET_SETTINGS_LABELS_LIST_FAILURE, payload);

/**
 * Add Label
 */

export const addSettingsLabelAction = (payload: string): TAddSettingsLabelAction =>
    createAction(ADD_SETTINGS_LABEL_ACTION, payload);

export const addSettingsLabelSuccess = (): TAddSettingsLabelSuccess =>
    createAction(ADD_SETTINGS_LABEL_SUCCESS);

export const addSettingsLabelFailure = (payload: string): TAddSettingsLabelFailure =>
    createAction(ADD_SETTINGS_LABEL_FAILURE, payload);

/**
 * Remove Label
 */

export const removeSettingsLabelAction = (payload: number): TRemoveSettingsLabelAction =>
    createAction(REMOVE_SETTINGS_LABEL_ACTION, payload);

export const removeSettingsLabelSuccess = (payload: IRemoveSettingsLabelSuccessPayload):
    TRemoveSettingsLabelSuccess => createAction(REMOVE_SETTINGS_LABEL_SUCCESS, payload);

export const removeSettingsLabelFailure = (payload: string): TRemoveSettingsLabelFailure =>
    createAction(REMOVE_SETTINGS_LABEL_FAILURE, payload);
